// Identidade estável para novos cadastros presenciais.
// Não tenta mesclar históricos antigos: apenas impede que o mesmo novo envio
// abra dois caminhos Firebase diferentes.
export function canonicalPhone(phone) {
  let digits = String(phone || "").replace(/\D/g, "");
  if ((digits.length === 12 || digits.length === 13) && digits.startsWith("55")) digits = digits.slice(2);
  if (digits.length === 10) digits = digits.slice(0, 2) + "9" + digits.slice(2);
  return digits;
}

function stableHash(input) {
  let hash = 2166136261;
  for (let i = 0; i < input.length; i += 1) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0).toString(36);
}

export function clientIdentityKey({ storeId, phone, name, product, createdAt }) {
  const store = Number(storeId || 0);
  const phoneKey = canonicalPhone(phone);
  const identity = phoneKey || stableHash([
    String(name || "").trim().toLowerCase(),
    String(product || "").trim().toLowerCase(),
    String(createdAt || ""),
  ].join("|"));
  return `client_${store}_${identity}`;
}

export function sameClientIdentity(a, b) {
  if (!a || !b || Number(a.storeId || 0) !== Number(b.storeId || 0)) return false;
  const phoneA = canonicalPhone(a.phone);
  const phoneB = canonicalPhone(b.phone);
  if (phoneA || phoneB) return Boolean(phoneA && phoneB && phoneA === phoneB);
  return clientIdentityKey(a) === clientIdentityKey(b);
}

export function normalizeClientSnapshot(data) {
  if (!data) return [];
  const entries = Array.isArray(data)
    ? data.map((value, index) => [String(index), value])
    : Object.entries(data);
  const seen = new Set();
  return entries
    .filter(([, value]) => Boolean(value) && typeof value === "object")
    .map(([firebaseKey, value]) => ({ ...value, id: String(firebaseKey) }))
    .filter((client) => {
      if (seen.has(client.id)) return false;
      seen.add(client.id);
      return true;
    });
}

export function runIdempotentWrite(pending, key, operation) {
  if (pending.has(key)) return pending.get(key);
  const write = Promise.resolve().then(operation);
  pending.set(key, write);
  const clear = () => {
    if (pending.get(key) === write) pending.delete(key);
  };
  write.then(clear, clear);
  return write;
}

export async function saveClientOnce({ candidate, findExisting, write }) {
  const existing = await findExisting(candidate);
  if (existing) return { client:existing, created:false };
  await write(candidate);
  return { client:candidate, created:true };
}

export function findPotentialClientDuplicates(clients) {
  const groups = new Map();
  (clients || []).forEach((client) => {
    const phone = canonicalPhone(client.phone);
    if (!phone) return;
    const key = `${Number(client.storeId || 0)}:${phone}`;
    const group = groups.get(key) || [];
    group.push(client);
    groups.set(key, group);
  });
  return [...groups.entries()]
    .filter(([, group]) => group.length > 1)
    .map(([key, clientsForIdentity]) => ({
      identity: key,
      storeId: Number(clientsForIdentity[0].storeId || 0),
      phone: canonicalPhone(clientsForIdentity[0].phone),
      clients: clientsForIdentity.map(({ id, name, createdAt, stage }) => ({ id, name, createdAt, stage })),
    }));
}